export { default as DropdownSubcompanies } from 'secured/components/layout/nav/DropdownSubcompanies';
export { default as DropdownUser } from 'secured/components/layout/nav/DropdownUser';



// WEBPACK FOOTER //
// src/modules/secured/components/layout/nav/index.js